// This is namespaced as "account" to avoid confusion with users that the web app might be acting on (e.g. for CX tools)
// There will only every be one account, the logged in user
export const NAMESPACE = 'account';

import type { UserID } from '@common/ids';
import { toUserID } from '@common/ids';
import type { Subscription } from './types';
export type { UserID };
export { toUserID };

export type UserStatus = 'invited' | 'active' | 'active-confirmed';

export interface State {
    isAuthenticated: boolean;
    userID?: UserID;
    firstName?: string;
    lastName?: string;
    email?: string;
    isBatsAccountLinked?: boolean;
    registrationDate?: string;
    bestSubscription?: Subscription | null;
    highestAccessLevel?: string | null;
    isFreeTrialEligible?: boolean;
}
